export default __webpack_public_path__ + "static/media/control-4.2488ac7f.svg";